import "core-js/modules/es.symbol.description.js";
const _excluded = ["okLabel", "cancelLabel", "title", "onOk", "onCancel", "handleClose", "open", "showX", "children", "hideActions", "hideCancel", "hideOk"],
  _excluded2 = ["hide"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import Button from "./Button.js";
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

/**
 * Wrapper of the Mui Dialog component
 * Prevent closing by clicking outside of the dialog by NOT passing in a handleClose prop
 * @returns
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Modal = _ref => {
  let {
      okLabel,
      cancelLabel,
      title,
      onOk,
      onCancel,
      handleClose,
      open,
      showX,
      children,
      hideActions,
      hideCancel,
      hideOk
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const titleRender = () => {
    if (showX) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(IconButton, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500]
          },
          children: /*#__PURE__*/_jsx(Close, {})
        }), title]
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: title
    });
  };
  return /*#__PURE__*/_jsxs(Dialog, _objectSpread(_objectSpread({
    open: open,
    onClose: handleClose
  }, props), {}, {
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    children: [/*#__PURE__*/_jsx(Typography, {
      id: "alert-dialog-title",
      variant: "modalTitle",
      children: titleRender()
    }), /*#__PURE__*/_jsx(DialogContent, {
      children: children
    }), hideActions ? null : /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(ShowHidden, {
        hide: hideCancel,
        onClick: onCancel,
        label: cancelLabel || 'Cancel',
        color: 'regressive'
      }), /*#__PURE__*/_jsx(ShowHidden, {
        hide: hideOk,
        onClick: onOk,
        autoFocus: true,
        label: okLabel || 'Ok'
      })]
    })]
  }));
};
Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  showX: PropTypes.bool,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
  onOk: PropTypes.func,
  onCancel: PropTypes.func,
  handleClose: PropTypes.func,
  hideActions: PropTypes.bool,
  hideCancel: PropTypes.bool,
  hideOk: PropTypes.bool,
  // Mui Dialog props (...props)
  // by defining them here, they will be consumed by Storybook for use in the controls area
  fullWidth: PropTypes.bool,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};
const ShowHidden = _ref2 => {
  let {
      hide
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return hide ? null : /*#__PURE__*/_jsx(Button, _objectSpread({}, props));
};
ShowHidden.propTypes = {
  hide: PropTypes.bool
};
export default Modal;